import { render, staticRenderFns } from "./StationEventDetailView.vue?vue&type=template&id=408952d4&scoped=true&"
import script from "./StationEventDetailView.vue?vue&type=script&lang=js&"
export * from "./StationEventDetailView.vue?vue&type=script&lang=js&"
import style0 from "./StationEventDetailView.vue?vue&type=style&index=0&id=408952d4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408952d4",
  null
  
)

/* custom blocks */
import block0 from "./StationEventDetailView.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408952d4')) {
      api.createRecord('408952d4', component.options)
    } else {
      api.reload('408952d4', component.options)
    }
    module.hot.accept("./StationEventDetailView.vue?vue&type=template&id=408952d4&scoped=true&", function () {
      api.rerender('408952d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaceEvents/StationEventDetailView.vue"
export default component.exports